module.exports = __webpack_public_path__ + "static/media/data-icon.aea86e62.svg";